<template>
  <!-- 首页轮播 -->
  <div id="head1">
    <div id="demo" class="carousel slide" data-bs-ride="carousel">
      <!-- 指示符 -->
      <div class="carousel-indicators">
        <button
          v-for="(image, index) in carouselImages"
          :key="index"
          :data-bs-target="'#demo'"
          :data-bs-slide-to="index"
          :class="{ active: index === 0 }"
          aria-current="true"
          aria-label="Slide {{ index + 1 }}"
        ></button>
      </div>
      <!-- 轮播图片 -->
      <div class="carousel-inner">
        <div
          v-for="(image, index) in carouselImages"
          :key="index"
          class="carousel-item"
          :class="{ active: index === 0 }"
        >
          <img :src="image.src" class="d-block w-100" alt="轮播图">
        </div>
      </div>
      <!-- 左右切换按钮 -->
      <button
        class="carousel-control-prev custom-carousel-button"
        type="button"
        data-bs-target="#demo"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        class="carousel-control-next custom-carousel-button"
        type="button"
        data-bs-target="#demo"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
    <!-- 首页宣传 -->
    <div id="head2">
      <div class="wrap">
        <div id="publicity">
          <p class="ad">{{ publicity.title }}</p><br>
          <p class="ad1">{{ publicity.subtitle }}</p>
        </div>
      </div>
      <div id="head3">
        <br>
        <p class="ad1" v-for="advantage in advantages" :key="advantage">{{ advantage }}</p>
        <p class="ad2" v-for="(description, index) in descriptions" :key="index">{{ description }}</p>
      </div>
    </div>
    <div id="head4">
      <div id="head4_left">
        <p class="ad3">{{ factory.title }}</p>
        <img :src="factory.image" alt="厂房一角">
      </div>
      <div id="head4_right">
        <div id="head4_foot">
          <span v-for="(assurance, index) in assurances" :key="index">{{ assurance }}</span>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import {
  carouselImages,
  publicity,
  advantages,
  descriptions,
  factory,
  assurances
} from './data.js';

// 轮播按钮样式数据
const carouselButtonBgColor = ref('#005cbf');
const carouselButtonOpacity = ref(0.1);

onMounted(() => {
  nextTick(() => {
    const demoElement = document.getElementById('demo');
    if (demoElement) {
      import('bootstrap/js/dist/carousel').then((module) => {
        const { default: Carousel } = module;
        if (Carousel) {
          new Carousel(demoElement);
          console.log('Carousel initialized successfully');
        } else {
          console.error('Carousel is undefined after import');
        }
      }).catch((error) => {
        console.error('Error importing Bootstrap carousel:', error);
      });
    } else {
      console.error('Element with id "demo" not found');
    }
  });
});
</script>

<style scoped>
/* 定义 CSS 变量 */
:root {
  --text-color-gray: #B5B5BE;
  --text-color-dark-gray: #555555;
  --shadow-color: #6c757d;
  --box-shadow-color: #888888;
  --base-font-size: 16px;
  --carousel-button-bg-color: #005cbf;
  --carousel-button-opacity: 0.1;
}

/* 轮播 */
.carousel-inner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 轮播按钮样式 */
.custom-carousel-button {
  background: var(--carousel-button-bg-color);
  opacity: var(--carousel-button-opacity);
}
/* 首页宣传 */
#head2 {
  background: url('../../public/static/images/bg_sub2.jpg') no-repeat;
  background-size: 100% 100%;
  height: 600px;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
}

.wrap {
  position: absolute;
  text-align: center;
  width: 100%;
}

.wrap div {
  line-height: 20px;
  padding-top: 20px;
}

#publicity .ad,
.ad2 {
  color: white;
}

.ad {
  font-size: calc(var(--base-font-size) * 1.875); /* 30px */
}

.ad1 {
  font-size: calc(var(--base-font-size) * 1.125); /* 18px */
}

#publicity .ad1 {
  padding-top: 8px;
  color: white;
}

/* CSS 伪类用法 */
.wrap div:after,
.wrap div:before {
  position: absolute;
  top: 60%;
  background: #ddd;
  content: "";
  height: 3px;
  width: 33%;
}

/* 调整背景横线的左右距离 */
.wrap div:before {
  left: 30px;
}

.wrap div:after {
  right: 30px;
}

#head3 {
  position: relative;
  top: 110px;
  text-align: center;
}

#head3 .ad1 {
  color: white;
}

#head4 {
  width: 100%;
  height: 650px;
  background: url("../../public/static/images/h4.jpg") no-repeat;
  background-size: 100% 100%;
}

#head4_left>.ad3 {
  font-size: calc(var(--base-font-size) * 1.75); /* 28px */
  color: var(--text-color-dark-gray);
  text-shadow: 7px 7px 3px var(--shadow-color);
  text-align: center;
}

#head4_left {
  float: left;
  width: 50%;
  color: #444444;
  height: 410px;
  position: relative;
  left: 50px;
  top: 65px;
  text-align: center;
  font-size: calc(var(--base-font-size) * 0.9375); /* 15px */
  font-weight: bold;
}

#head4_left img {
  box-shadow: 10px 10px 5px var(--box-shadow-color);
  width: 80%;
  height: 80%;
}

#head4_right {
  float: left;
  position: relative;
  top: 15px;
  right: 30px;
  width: 50%;
  height: 410px;
  text-align: center;
  font-weight: bold;
  padding-top: 120px;
  /* transform: rotate(-10deg); */
  overflow: hidden;
}

#head4_foot>span {
  font-size: calc(var(--base-font-size) * 1.125); /* 18px */
  font-weight: bold;
  line-height: 50px;
  font-family: 微软雅黑;
  color: var(--text-color-dark-gray);
  text-shadow: 7px 7px 3px var(--shadow-color);
  display: block; /* 实现换行 */
}

/* 媒体查询 */
@media (min-width: 375px) {
  :root {
    --base-font-size: 12px;
  }
  .wrap div:before {
    left: 10px;
  }
  .wrap div:after {
    right: 10px;
  }
  #head4_foot span {
    font-size: calc(var(--base-font-size) * 0.583); /* 7px */
  }
  #head4_left img {
    width: 50%;
    height: 50%;
  }
}

@media (min-width: 768px) {
  :root {
    --base-font-size: 14px;
  }
  .wrap div:before {
    left: 18px;
  }
  .wrap div:after {
    right: 18px;
  }
  #head4_foot span {
    font-size: calc(var(--base-font-size) * 1); /* 14px */
  }
  #head4_left img {
    width: 60%;
    height: 60%;
  }
}

@media (min-width: 992px) {
  :root {
    --base-font-size: 16px;
  }
  .wrap div:before {
    left: 30px;
  }
  .wrap div:after {
    right: 30px;
  }
  #head4_foot span {
    font-size: calc(var(--base-font-size) * 1.125); /* 18px */
  }
  #head4_left img {
    width: 80%;
    height: 80%;
  }
}

@media (min-width: 1200px) {
  :root {
    --base-font-size: 18px;
  }
  .wrap div:before {
    left: 35px;
  }
  .wrap div:after {
    right: 35px;
  }
  #head4_foot span {
    font-size: calc(var(--base-font-size) * 1.278); /* 23px */
  }
  #head4_left img {
    width: 100%;
    height: 100%;
  }
}
</style>